export default {
    bangdan: [
        {
            name: "微博",
            description: "随时随地发现新鲜事！微博带你欣赏世界上每一个精彩瞬间，了解每一个幕后故事。分享你想表达的，让全世界都能听到你的心声！",
            pic: "weibo",
            link: "https://weibo.com"
        },
        {
            name: "淘宝",
            description: "亚洲较大的网上交易平台，提供各类服饰、美容、家居、数码、话费/点卡充值…",
            pic: "taobao",
            link: "https://www.taobao.com"
        },
        {
            name: "京东",
            description: "专业的综合网上购物商城,为您提供正品低价的购物选择、优质便捷的服务体验。",
            pic: "jingdong",
            link: "https://www.jd.com"
        },
        {
            name: "知乎",
            description: "有问题,上知乎。知乎是中文互联网知名知识分享平台",
            pic: "zhihu",
            link: "https://www.zhihu.com"
        },
        {
            name: "腾讯视频",
            description: "腾讯视频致力于打造中国领先的在线视频媒体平台,以丰富的内容、极致的观看体验",
            pic: "tengxunshipin",
            link: "https://v.qq.com"
        },
        {
            name: "爱奇艺",
            description: "爱奇艺是拥有海量、优质、高清的网络视频的大型视频网站,专业的网络视频播放平台",
            pic: "iqiyi",
            link: "https://www.iqiyi.com"
        },
        {
            name: "哔哩哔哩",
            description: "bilibili是国内知名的视频弹幕网站,这里有最及时的动漫新番,最棒的ACG氛围,最有创意的Up主。",
            pic: "bilibili",
            link: "https://www.bilibili.com"
        },
        {
            name: "优酷",
            description: "频服务平台,提供视频播放,视频发布,视频搜索,视频分享",
            pic: "youku",
            link: "https://www.youku.com"
        },
        {
            name: "搜狐",
            description: "搜狐网为用户提供24小时不间断的最新资讯,及搜索、邮件等网络服务。内容包括全球热点事件、突发新闻",
            pic: "sohu",
            link: "http://www.sohu.com/"
        },
        {
            name: "新浪网",
            description: "浪网为全球用户24小时提供全面及时的中文资讯，内容覆盖国内外突发新闻事件、体坛赛事、娱乐时尚、产业资",
            pic: "xinlang",
            link: "https://www.sina.com.cn/"
        },
        {
            name: "网易",
            description: "网易是中国领先的互联网技术公司,为用户提供免费邮箱、游戏、搜索引擎服务,开设新闻、娱乐、体育等30多个内容频道,及博客",
            pic: "wangyi",
            link: "https://www.163.com"
        },
        {
            name: "今日头条",
            description: "基于数据挖掘的推荐引擎产品,它为用户推荐有价值的、个性化的信息,提供连接人与信息的新型服务",
            pic: "toutiao",
            link: "https://www.toutiao.com"
        },
        {
            name: "豆瓣",
            description: "提供图书、电影、音乐唱片的推荐、评论和价格比较,以及城市独特的文化生活。",
            pic: "douban",
            link: "https://www.douban.com"
        },
        {
            name: "起点中文网",
            description: "小说阅读,精彩小说尽在起点中文网. 起点中文网提供玄幻小说,武侠小说,原创小说,网游小说,都市小说",
            pic: "qidianzhongwenwang",
            link: "https://www.qidian.com"
        },
        {
            name: "58同城",
            description: "为你提供房产、招聘、黄页、团购、交友、二手、宠物、车辆、周边游等海量分类信息",
            pic: "58tongcheng",
            link: "https://www.58.com"
        },
        {
            name: "房天下",
            description: "房天下是房地产家居网络平台,提供及时的房地产新闻资讯内容,为楼盘提供网上浏览、业主论坛和社区网站",
            pic: "fangtianxia",
            link: "http://www.fang.com"
        },
        {
            name: "慢慢买",
            description: "比价网,导购网站平台,数码比价,家电比价，购物比价",
            pic: "manmanbuy",
            link: "http://manmanbuy.com/"
        }
    ],
    tuijian: [
        {
            name: "微博",
            description: "随时随地发现新鲜事！微博带你欣赏世界上每一个精彩瞬间，了解每一个幕后故事。分享你想表达的，让全世界都能听到你的心声！",
            pic: "weibo",
            link: "https://weibo.com"
        },
        {
            name: "知乎",
            description: "有问题,上知乎。知乎是中文互联网知名知识分享平台",
            pic: "zhihu",
            link: "https://www.zhihu.com"
        },
        {
            name: "豆瓣",
            description: "提供图书、电影、音乐唱片的推荐、评论和价格比较,以及城市独特的文化生活。",
            pic: "douban",
            link: "https://www.douban.com"
        },
        {
            name: "果壳",
            description: "果壳网是一个泛科技主题网站,提供负责任、有智趣、贴近生活的内容,你可以在这里阅读",
            pic: "guoke",
            link: "http://www.guokr.com"
        },
        {
            name: "煎蛋",
            description: "煎蛋以译介方式传播网络新鲜资讯... 是不是该抓一抓网站的运营情况了?是不是该提高一下审核人员的..",
            pic: "jiandan",
            link: "http://jandan.net"
        },
        {
            name: "虎嗅",
            description: "聚合优质的创新信息与人群，捕获精选|深度|犀利的商业科技资讯。在虎嗅，不错过互联网的每个重要时刻。",
            pic: "huxiu",
            link: "https://www.huxiu.com"
        },
        {
            name: "音悦Tai",
            description: "音悦Tai-是以高清MV为主的娱乐视频网站，提供高品质音乐视频在线观看服务。同时也是偶像和粉丝的聚集地，既可以购买明星专辑和周边，也可以参与各式各样的线下活动。",
            pic: "yinyue",
            link: "http://www.yinyuetai.com"
        },
        {
            name: "好奇心研究",
            description: "好奇心日报以商业视角观察生活并启发你的好奇心，囊括商业报道、科技新闻、生活方式等各个领域，致力成为这个时代最好的媒体，为用户提供最好的新闻资讯。",
            pic: "haoqixinyanjiusuo",
            link: "http://www.qdaily.com"
        },
        {
            name: "丁香园",
            description: "医学,药学,生物,医学论坛,医生,临床,医学知识,病例讨论,医学考试,论文,实验方法,数据库,文献,疾病,社区,用药助手,丁香园",
            pic: "dingxiangyuan",
            link: "http://www.dxy.cn"
        },
        {
            name: "医学微视",
            description: "中国医学科普微视频百科全书",
            pic: "yixueweishi",
            link: "https://www.mvyxws.com/"
        },
        {
            name: "全历史",
            description: "通过高度时空化、关联化数据的方式构造及展现数字人文内容，尤其是历史知识。让用户沉浸在纵横开阔、左图右史的（历史、人文、社科等）知识海洋中。",
            pic: "quanlishi",
            link: "https://www.allhistory.com/"
        },
        {
            name: "壹心理",
            description: "壹心理，2000万人选择的心理学服务平台。你内心困惑的问题，在壹心理可以找到答案。我们提供系统的心理健康服务：包括心理学课程、心理咨询、心理测评、心理FM以及心理科普文章。",
            pic: "yixinli",
            link: "https://www.xinli001.com"
        },
        {
            name: "多邻国",
            description: "多邻国是世界上最受欢迎的语言学习平台。免费、有趣、科学。现在就登录 duolingo.com 或手机应用开始学习吧!",
            pic: "duolinguo",
            link: "http://www.duolingo.cn/"
        },
        {
            name: "维基百科",
            description: "甩百度百科几条街，可惜中文版被墙，怎么上自己想",
            pic: "weijibaike",
            link: "https://zh.wikipedia.org/"
        },
        {
            name: "追剧",
            description: "Neets追剧管理服务，旨在提供影视主题订阅、更新推送、网页聚合搜索。为广大动漫、美剧、日剧、韩剧、国产剧等爱好者，带来更愉快的追剧体验！",
            pic: "zhuiju",
            link: "https://neets.cc/"
        },
        {
            name: "豆瓣FM",
            description: "让好音乐继续 豆瓣精选",
            pic: "doubanfm",
            link: "https://douban.fm/"
        },
        {
            name: "TypingClub",
            description: "通过684个小关卡,提高打字速度,摆脱“二指禅”想起了曾经微机课上,被金山打字通支配的恐惧",
            pic: "typingclub",
            link: "https://www.typingclub.com/"
        },
        {
            name: "中国大学",
            description: "中国大学MOOC(慕课) 是国内优质的中文MOOC学习平台,由爱课程网携手网易云课堂打造。平台拥有包括985高校在内提供的千余门课程,其中首批获得认定的国家精品在线开放",
            pic: "zhongguodaxue",
            link: "https://www.icourse163.org/"
        },
        {
            name: "我要自学网",
            description: "我要自学网-视频教程|免费教程|自学电脑|3D教程|平面教程|影视动画教程|办公教程|机械设计教程|网站设计教程,我要自学网,视频教程",
            pic: "woyaozixuewang",
            link: "http://www.51zxw.net/"
        },
        {
            name: "网易公开课",
            description: "网易视频公开课频道推出国内外名校公开课,涉及广泛的学科,名校老师认真讲解深度剖析,网易视频公开课频道搭建起..",
            pic: "wangyigongkaike",
            link: "https://open.163.com/"
        },
        {
            name: "腾讯课堂",
            description: "腾讯推出的专业职业培训在线教育平台，聚合大量优质教育机构和名师",
            pic: "tengxunketang",
            link: "https://ke.qq.com/"
        },
        {
            name: "一纳米学习",
            description: "1纳米学习导航，最专业的学习网站导航。收集国内外最新最酷的学习网站！学习必备！找资料必备！",
            pic: "yinamixuexi",
            link: "http://1nami.com/"
        }
    ],
    shipin: [
        {
            name: "腾讯视频",
            description: "腾讯视频致力于打造中国领先的在线视频媒体平台,以丰富的内容、极致的观看体验",
            pic: "tengxunshipin",
            link: "https://v.qq.com"
        },
        {
            name: "爱奇艺",
            description: "爱奇艺是拥有海量、优质、高清的网络视频的大型视频网站,专业的网络视频播放平台",
            pic: "iqiyi",
            link: "https://www.iqiyi.com"
        },
        {
            name: "哔哩哔哩",
            description: "bilibili是国内知名的视频弹幕网站,这里有最及时的动漫新番,最棒的ACG氛围,最有创意的Up主。",
            pic: "bilibili",
            link: "https://www.bilibili.com"
        },
        {
            name: "AcFun",
            description: "一家弹幕视频网站，致力于为每一个人带来欢乐。",
            pic: "acfun",
            link: "https://www.acfun.cn"
        },
        {
            name: "芒果TV",
            description: "大家都在看的在线视频网站-热门综艺最新电影电视剧在线观看",
            pic: "mangguotv",
            link: "https://www.mgtv.com/"
        },
        {
            name: "优酷",
            description: "频服务平台,提供视频播放,视频发布,视频搜索,视频分享",
            pic: "youku",
            link: "https://www.youku.com"
        },
        {
            name: "梨视频",
            description: "中国领先的资讯类短视频生产者,由资深媒体团队和全球拍客共同创造,专注为年青一代提供适合移动终端观看和分享的短视频产品,内容涵盖商业、社会",
            pic: "lishipin",
            link: "https://www.pearvideo.com/"
        },
        {
            name: "西瓜视频",
            description: "一个开眼界、涨知识的视频 App,作为国内领先的中视频平台,它源源不断地为不同人群提供优质内容,让人们看到更丰富和有深度的世界,收获轻松的获得感,点亮对生活的好奇心。",
            pic: "xiguashipin",
            link: "https://www.ixigua.com/"
        },
        {
            name: "PP视频",
            description: "国内领先的综合视频门户网站平台，视频内容丰富多元，包括电视剧、电影、动漫、综艺、体育、娱乐、游戏、搞笑、旅游、财富、少儿、教育、",
            pic: "ppshipin",
            link: "http://www.pptv.com/"
        },
        {
            name: "56视频",
            description: "中国原创视频网站,免费上传搞笑逗趣生活视频，观看优质丰富的特色节目，关注感兴趣的原创导演和美女解说，快速分享及评论互动。",
            pic: "56shipin",
            link: "https://www.56.com/"
        },
        {
            name: "搜狐视频",
            description: "搜狐旗下专业的综合视频网站，提供正版高清电影、电视剧、综艺、纪录片、动漫等。网罗最新最热新闻、娱乐咨询，同时提供免费视频空间和视频分享",
            pic: "souhushipin",
            link: "https://tv.sohu.com/"
        },
        {
            name: "乐视视频",
            description: "是以正版,高清影视剧为主的视频门户,乐视旗下专业影视剧视频网站。为用户提供正版高清电影,电视剧,动漫,综艺等视频在线观看",
            pic: "leshitv",
            link: "http://www.le.com/"
        },
        {
            name: "咪咕视频",
            description: "在线视频网站-海量正版高清视频在线观看",
            pic: "migushipin",
            link: "http://www.miguvideo.com/"
        },
        {
            name: "酷绘",
            description: "以高清影视剧为主的视频网站。为用户提供高清电影,电视剧,动漫,综艺等视频在线观看,以及视频分享,视频搜索等服务。",
            pic: "kuhui",
            link: "http://www.kuhuiv.com/"
        },
        {
            name: "NO视频",
            description: "为用户提供及时的海外热门剧集在线观看，24小时多平台同步，友好无广告，致力于最轻松的追剧体验。",
            pic: "noshipin",
            link: "http://www.novipnoad.com/"
        },
        {
            name: "好看视频",
            description: "拥有数十万视频创作者,独家海量高清短视频,分类覆盖VLOG、影视、娱乐、搞笑、音乐、游戏等全方位优质视频,每天观看次数数十亿次,深度了解您的喜好,好看到停...",
            pic: "haokanshipin",
            link: "https://haokan.baidu.com/"
        },
    ],
    dianying: [
        {
            name: "豆瓣电影",
            description: "提供最新的电影介绍及评论包括上映影片的影讯查询及购票服务。你可以记录想看、在看和看过的电影电视剧,顺便打分、写影评。根据你的口味,豆瓣电影会推荐好...",
            pic: "douban",
            link: "https://movie.douban.com/"
        },
        {
            name: "音范丝",
            description: "影音集是一个电影爱好者的资讯分享站，推荐优秀电影，人工精选高分影片，部部精品。",
            pic: "yinfansi",
            link: "https://www.yinfans.me/"
        },
        {
            name: "片库",
            description: "高清电影,电影下载,BT种子,BT下载",
            pic: "pianku",
            link: "https://www.btnull.re/"
        },
        {
            name: "夜晚影视库",
            description: "电影爱好者的天堂，为您倾情打造全网最全高清影视库， 带来最新、最快、最全的纯净在线高清影视资源",
            pic: "yewanyingshiku",
            link: "https://v.yewan.info/"
        },
        {
            name: "电影天堂",
            description: "最好的迅雷电影下载网，分享最新电影，高清电影、综艺、动漫、电视剧等下载",
            pic: "dianyingtiantang",
            link: "https://www.dytt8.net/"
        },
        {
            name: "电影蜜蜂",
            description: "为您提供高清电影资源,好看的电影推荐.在这里您可以找到世界各国好看的电影,以及各类..",
            pic: "dianyingmifeng",
            link: "https://www.idybee.com/"
        },
        {
            name: "泡饭影视",
            description: "收罗全网高清资源下载链接的资源博客，院线大片，美剧，英剧，日剧，韩剧，港台剧，大陆剧，应有尽有！",
            pic: "paofanyingshi",
            link: "http://www.chapaofan.com/"
        },
        {
            name: "电影FM",
            description: "一个专注于电影推荐的网站，通过记录和分析你看过的电影，找出符合你口味的推荐，你还可以制作属于自己的海报墙，拥有自己的电影主页。电影FM还提供电影播放地址及磁力链接下载。",
            pic: "dianyingfm",
            link: "http://www.dianying.fm/"
        },
        {
            name: "飘花电影",
            description: "最新电影,3E迅雷电影下载网(原3edyy.com)-每天搜集最新迅雷免费电影下载。为使用迅雷软件的用户提供最新的免费电影下载、小电影下载、高清电影下载等服务。",
            pic: "piaohuadianying",
            link: "https://www.piaohua.com/"
        },
        {
            name: "BT电影天堂",
            description: "为广大影迷朋友们提供最新最热门的迅雷电影下载。我们专注于高清电影下载服务，全力打造优秀的BT种子、迅雷种子下载网站！",
            pic: "btdianyingtiantang",
            link: "http://www.btbtdy.me/"
        },
        {
            name: "葡萄影视",
            description: "国内更新速度最快最全的，2017最新电影，韩国电视剧、香港TVB电视剧、韩剧、日剧、美剧、综艺的在线观看和剧集交流场所，在线观看有吉吉影音、西瓜影音、迅雷下载等播放高清播放模式，葡萄影视网",
            pic: "putaoyingshi",
            link: "http://www.putaoys.com/"
        }
    ],
    gouwu: [
        {
            name: "淘宝",
            description: "亚洲较大的网上交易平台，提供各类服饰、美容、家居、数码、话费/点卡充值…",
            pic: "taobao",
            link: "https://www.taobao.com"
        },
        {
            name: "京东",
            description: "专业的综合网上购物商城,为您提供正品低价的购物选择、优质便捷的服务体验。",
            pic: "jingdong",
            link: "https://www.jd.com"
        },
        {
            name: "慢慢买",
            description: "比价网,导购网站平台,数码比价,家电比价，购物比价",
            pic: "manmanbuy",
            link: "http://manmanbuy.com/"
        },
        {
            name: "蘑菇街",
            description: "中国领先的时尚目的地。公司通过形式多样的时尚内容，种类丰富的时尚商品，以及结合红人直播、买手选款+智能推荐的售卖方式，让人们在分享和发现流行趋势的同时，尽情享受优质的购物体验。2011年，蘑菇街正式上线",
            pic: "mogujie",
            link: "https://www.mogujie.com/"
        },
        {
            name: "唯品会",
            description: "以1-7折超低折扣对全球各大品牌进行限时特卖，商品囊括服装、化妆品、家居、奢侈品等上千品牌。100%正品、低价、货到付款、7天无理由退货。",
            pic: "weipinhui",
            link: "https://www.vip.com/"
        },
        {
            name: "贝贝",
            description: "1亿妈妈信赖之选，每天1折起限时特卖，童装童鞋、母婴用品、居家百货、女装鞋包等天天上新，正品保证，全场包邮。",
            pic: "beibei",
            link: "http://www.beibei.com/"
        },
    ],
    yinyue: [
        {
            name: "网易云音乐",
            description: "一款专注于发现与分享的音乐产品,依托专业音乐人、DJ、好友推荐及社交功能,为用户打造全新的音乐生活。",
            pic: "wangyiyunyinyue",
            link: "https://music.163.com/"
        },
        {
            name: "酷狗音月",
            description: "为您免费提供最全的在线音乐试听下载,以及全球海量电台和MV播放服务、最新音乐播放器下载。酷狗音乐 和音乐在一起。",
            pic: "kugouyinyue",
            link: "http://www.kugou.com/"
        },
        {
            name: "QQ音乐",
            description: "海量音乐在线试听、新歌热歌在线首发、歌词翻译、手机铃声下载、高品质无损音乐试听、海量无损曲库、正版音乐下载、空间...",
            pic: "qqyinyue",
            link: "https://y.qq.com/"
        },
        {
            name: "虾米音乐",
            description: "提供高品质音乐MP3的个性化推荐、发布、P2P下载服务,以及线下音乐活动等互动内容... 基于你最近听的音乐 今日推荐歌单 收藏 添加到 分享到基于最近流行为你推荐不感兴...",
            pic: "xiamiyinyue",
            link: "https://www.xiami.com/"
        },
        {
            name: "音乐下载",
            description: "多站合一音乐搜索解决方案,可搜索试听免费下载网易云音乐、QQ音乐、酷狗音乐、酷我音乐、虾米音乐、百度音乐、一听音乐、咪咕音乐、荔枝FM、蜻蜓FM...",
            pic: "yinyuexiazai",
            link: "https://music.sounm.com/"
        },
        {
            name: "9酷音乐",
            description: "专业的在线音乐试听mp3下载网站.收录了网上最新歌曲和流行音乐,网络歌曲,好听的歌,非主流音乐,QQ音乐,经典老歌,劲舞团歌曲,搞笑歌曲,儿童..",
            pic: "9kuyinyue",
            link: "http://www.9ku.com/"
        },
        {
            name: "咪咕音乐",
            description: "为您打造音乐、视频、 阅读、游戏、动漫的数字内容聚合平台 给您全新的娱乐体验。",
            pic: "miguyinyue",
            link: "http://www.migu.cn//"
        },
        {
            name: "千千音乐",
            description: "中国音乐门户之一,为你提供海量正版高品质音乐,权威的音乐榜单,快速的新歌速递,契合你的主题电台,人性化的歌曲搜索,让你更快地找到喜爱的音乐",
            pic: "qianqianyinyue",
            link: "http://music.taihe.com/"
        },
        {
            name: "echo",
            description: "年轻人里最流行的音乐APP之一,也是全球最大的3D音乐平台。echo将颠覆你对音乐的一切体验。在这里,发现前所未有的好听音乐、3D神奇立体音效、弹幕评论..",
            pic: "echo",
            link: "http://www.app-echo.com"
        },
        {
            name: "音悦Tai",
            description: "音悦Tai-是以高清MV为主的娱乐视频网站，提供高品质音乐视频在线观看服务。同时也是偶像和粉丝的聚集地，既可以购买明星专辑和周边，也可以参与各式各样的线下活动。",
            pic: "yinyue",
            link: "http://www.yinyuetai.com"
        },
        {
            name: "豆瓣FM",
            description: "让好音乐继续 豆瓣精选",
            pic: "doubanfm",
            link: "https://douban.fm/"
        },
        {
            name: "蜻蜓FM",
            description: "有声小说-有声读物-电台广播在线听书-蜻蜓FM",
            pic: "qingtingfm",
            link: "https://www.qingting.fm/"
        },
        {
            name: "喜马拉雅",
            description: "专业的音频分享平台,汇集了有声小说,有声读物,有声书,FM电台,儿童睡前故事,",
            pic: "ximalaya",
            link: "https://www.ximalaya.com/"
        },
        {
            name: "猫耳FM",
            description: "第一家弹幕音图站,同时也是中国声优基地,在这里可以听电台,音乐,翻唱,小说和广播剧,用二次元声音连接三次元.",
            pic: "maoerfm",
            link: "https://www.missevan.com/"
        },
        {
            name: "荔枝FM",
            description: "专业的音频分享平台,汇集了听音乐,英语,睡前故事,儿童故事,有声小说,相声段子,历史人文,有声书等数亿条音频,超过2亿用户选择的网络FM,随时随地，想听就听，你喜爱的音频尽在荔枝。",
            pic: "lizhifm",
            link: "https://www.lizhi.fm/"
        },
        {
            name: "凤凰FM",
            description: "金牌节目这里有最火的新闻主播,有最新的新闻mp3下载,精彩纷呈,不容错过! 好声音尽在凤凰FM,凤凰电台！",
            pic: "fenghuangfm",
            link: "http://diantai.ifeng.com/"
        },
        {
            name: "企鹅FM",
            description: "腾讯公司推出的音频电台分享平台，提供最热门的网络电台节目。点歌台、鬼故事、星座风水",
            pic: "qiefm",
            link: "https://fm.qq.com/"
        }
    ],
    zhibo: [
        {
            name: "斗鱼",
            description: "每个人的直播平台提供高清、快捷、流畅的视频直播和游戏赛事直播服务,包含英雄联盟lol直播、穿越火线cf直播、dota2直播、美女直播等各类热门游戏赛事直播和各种.",
            pic: "douyuzhibo",
            link: "https://www.douyu.com/"
        },
        {
            name: "B站直播",
            description: "热门游戏直播,游戏直播,高清游戏直播,电子竞技直播,lol直播,cf直播,dota2直播,美女直播,弹幕,字幕,动漫,动漫音乐,游戏",
            pic: "bilibili",
            link: "https://live.bilibili.com/"
        },
        {
            name: "虎牙",
            description: "以游戏直播为主的弹幕式互动直播平台,累计注册用户2亿,提供热门游戏直播、电竞赛事直播与游戏赛事直播,手游直播等。包含王者荣耀,绝地求生,荒野行动等游戏...",
            pic: "huyazhibo",
            link: "http://www.huya.com/"
        },
        {
            name: "战旗直播",
            description: "提供高清、流畅的视频直播和电子竞技游戏直播。包括三国杀直播、LOL英雄联盟直播、炉石传说直播、dota2直播等各类热门游戏赛事。战旗直播为您提供全新的...",
            pic: "zhanqizhibo",
            link: "https://www.zhanqi.tv/"
        },
        {
            name: "花椒直播",
            description: "一个聚集超高颜值明星大咖、美女帅哥、热门网红、校花校草、逗比萌妹的手机直播社交平台,这里有明星发布会、花边新闻、才艺展示、生活趣闻、聊天互、唱歌...",
            pic: "huajiaozhibo",
            link: "https://www.huajiao.com/"
        },
        {
            name: "章鱼直播",
            description: "全民原创互动的体育直播,为观众提供覆盖面最广的比赛和多样化的直播体验。章鱼的直播内容包括中超、英超...",
            pic: "zhangyuzhibo",
            link: "http://www.zhangyu.tv/"
        },
        {
            name: "九秀网",
            description: "集视频交友与美女在线表演为一体的视频交友网站,这里有美女视频直播、美女视频聊天、美女视频表演,看美女主播,与美女视频互动。九秀,一个美女如云网站!",
            pic: "jiuxiuwang",
            link: "http://www.9xiu.com/"
        },
        {
            name: "YY",
            description: "致力于打造全民娱乐的互动直播平台,以多样的美女互动、优质的直播内容、极致的互动体验,满足用户音乐、舞蹈、户外等直播及绝地求生、王者荣耀等热门游戏直播的观看...",
            pic: "yyzhibo",
            link: "http://www.yy.com/"
        }
    ],
    nansheng: [
        {
            name: "有货",
            description: "年轻人潮流购物中心，中国潮流商品购物网站。作为YOHO!旗下的购物平台，汇集了全球潮流时尚商品和国内流行商品，★全场品牌正品保证，支持货到付款★",
            pic: "youhuo",
            link: "https://www.yohobuy.com/"
        },
        {
            name: "虎扑",
            description: "一个认真而有趣的社区,每天有众多JRs在虎扑分享自己对篮球、足球、游戏电竞、运动装备、影视、汽车、数码、情感等一切人和事的见解,热闹、真实、有温度。",
            pic: "hupu",
            link: "https://www.hupu.com/"
        },
        {
            name: "直播吧",
            description: "知名体育平台,主要为足球迷,篮球迷等提供直播,新闻资讯,数据,论坛社区,原创报道,视频集锦等服务",
            pic: "zhiboba",
            link: "https://www.zhibo8.cc/"
        },
        {
            name: "太平洋电脑",
            description: "专业IT门户网站,为用户和经销商提供IT资讯和行情报价,涉及电脑,手机,数码产品,软件等.",
            pic: "taipingyangdiannao",
            link: "https://www.pconline.com.cn/"
        }, {
            name: "OP.GG",
            description: "Real-time LoL Stats! Check your Summoner, Live Spectate and using powerful global League of Legends Statistics!",
            pic: "opgg",
            link: "http://www.op.gg/"
        },
        {
            name: "多玩游戏",
            description: "国内专业的游戏门户，玩家论坛与视频网站。提供了专业的游戏资讯、强大的游戏攻略、游戏工具盒子和大量的ACG视频。多玩游戏，多交朋友，多看视频。",
            pic: "duowanyouxi",
            link: "http://www.duowan.com/"
        },
        {
            name: "龍柒",
            description: "CONVERSE 携手潮流球鞋店 SNEAKERSNSTUFF 全新 诠释 ONE STAR 鞋款 群雄逐鹿,Air Jordan NBA Pack 灵感爆发,Air Jordan 3 “Chlorophyll” 夏日冲击,adidas Yu..",
            pic: "longqi",
            link: "http://www.long7.com/"
        },
        {
            name: "TapTap",
            description: "一个推荐高品质手游的手游分享社区，实时同步全球各大应用市场游戏排行榜，与全球玩家共同交流并发掘高品质手游。每一款推荐游戏，都是由专业的测评团队从全球海量的游戏中精选而出，只为你提供好玩的手机游戏。",
            pic: "taptap",
            link: "https://www.taptap.com/"
        },
        {
            name: "新新球鞋网",
            description: "国内最具有影响力的著名运动鞋文化网站之一，主体定位于运动咨询类服务，目的就是让更多的朋友了解认识运动鞋及相关方面的知识，提供最新、最及时的咨询信息，让大家在运动的同时了解运动产品及其相关的方方面面信息。",
            pic: "xinxinqiuxiewang",
            link: "https://www.x-kicks.com/"
        },
        {
            name: "Chiphell",
            description: "比较豪的评测社区，什么都有",
            pic: "chiphell",
            link: "https://www.chiphell.com/"
        },
        {
            name: "汽车之家",
            description: "为您提供最新汽车报价，汽车图片，汽车价格大全，最精彩的汽车新闻、行情、评测、导购内容，是提供信息最快最全的中国汽车网站。",
            pic: "qichezhijia",
            link: "https://www.autohome.com.cn/"
        },
        {
            name: "天涯社区",
            description: "网络人物网络事件的发源地, 网络名词网络流行语的创造者.",
            pic: "tianyashequ",
            link: "http://focus.tianya.cn/"
        },
        {
            name: "同花顺财经",
            description: "一家专业的互联网金融数据服务商,为您全方位提供财经资讯及全球金融市场行情,覆盖股票、基金、期货、外汇、...",
            pic: "tonghuashuncaijing",
            link: "http://www.10jqka.com.cn/"
        },
        {
            name: "中关村在线",
            description: "中国领先的IT信息与商务门户, 包括新闻, 商城, 硬件, 下载, 游戏, 手机, 评测等40个大型频道，每天发布大量各类产品促销信息及文章专题，是IT行业的厂商, 经销商, IT产品, 解决方案的提供场所",
            pic: "zhongguancunzaixian",
            link: "http://www.zol.com.cn/"
        },
        {
            name: "机锋网",
            description: "中国最大的Android安卓平台,中关村智造大街唯一入驻媒体。也是国内唯一 一家定位在手机机友玩家、手机发烧友的服务平台。作为安卓手机玩家基地,机锋坚持为中国对...",
            pic: "jifengwang",
            link: "http://www.gfan.com/"
        },
        {
            name: "雷锋网",
            description: "国内最早关注人工智能和智能硬件领域的互联网科技媒体，内容涵盖人工智能、智能硬件、机器人、智能驾驶、ARVR、网络安全、物联网、未来医疗、金融科技等9大领域。雷锋网致力于连接和服务学术界、工业界与投资界，为用户提供更专",
            pic: "leifengwang",
            link: "https://www.leiphone.com/"
        },
        {
            name: "ZEALER",
            description: "中国具有影响力的科技视频平台。创始人兼CEO王自如 和 ZEALER 坚持打造兼具行业洞察力与品质感的科技视频内容,输出「科技 Plus」生活主张。目前涵盖消费电子、智能..",
            pic: "zealer",
            link: "http://www.zealer.com/"
        }
    ],
    nvsheng: [
        {
            name: "蘑菇街",
            description: "中国领先的时尚目的地。公司通过形式多样的时尚内容，种类丰富的时尚商品，以及结合红人直播、买手选款+智能推荐的售卖方式，让人们在分享和发现流行趋势的同时，尽情享受优质的购物体验。2011年，蘑菇街正式上线",
            pic: "mogujie",
            link: "https://www.mogujie.com/"
        },
        {
            name: "太平洋时尚",
            description: "集时髦、实用、时效为一体的全明星时尚网络和专业女性资讯平台。着力打造时尚、独立、健康的新时代女性，传递女性期待的一切。PClady提供专业的美容消费指南、解读时髦的时装趋势",
            pic: "taipingyangshishang",
            link: "https://www.pclady.com.cn/"
        },
        {
            name: "唯品会",
            description: "以1-7折超低折扣对全球各大品牌进行限时特卖，商品囊括服装、化妆品、家居、奢侈品等上千品牌。100%正品、低价、货到付款、7天无理由退货。",
            pic: "weipinhui",
            link: "https://www.vip.com/"
        },
        {
            name: "下厨房",
            description: "美食菜谱网倡导在家烹饪、健康的生活方式,提供有版权的实用菜谱做法与饮食知识,提供厨师和美食爱好者一个记录、分享的平台。",
            pic: "xiachufang",
            link: "http://www.xiachufang.com/"
        },
        {
            name: "Onlylady",
            description: "女人志女性时尚生活平台是专业的女性时尚网站，为广大用户提供专业的时尚潮流、美容方法、流行趋势、服饰时装资讯，打造专业时尚、美容、生活、达人、互动平台。",
            pic: "onlylady",
            link: "http://www.onlylady.com/"
        },
        {
            name: "红袖添香",
            description: "提供古言、现言、原创、玄幻、都市、言情、娱乐、种田、科幻、悬疑、灵异、穿越、重生、宠文等小说,最新全本免费手机小说阅读推荐,精彩尽在红袖添香。",
            pic: "hongxiutianxiang",
            link: "https://www.hongxiu.com/"
        },
        {
            name: "七丽时尚",
            description: "为您提供最喜爱的时尚、美容、发型、减肥等权威资讯及各种简单易学的时尚类视频教程；如果您酷爱时尚，热爱生活，一定会喜欢七丽时尚网。",
            pic: "qilishishang",
            link: "http://www.7y7.com/"
        },
        {
            name: "贝贝",
            description: "1亿妈妈信赖之选，每天1折起限时特卖，童装童鞋、母婴用品、居家百货、女装鞋包等天天上新，正品保证，全场包邮。",
            pic: "beibei",
            link: "http://www.beibei.com/"
        },
        {
            name: "她生活",
            description: "穿衣搭配网是全球最专业服饰搭配网站。具有海量和权威的穿衣搭配指南。学习穿衣搭配的技巧，教你穿出气质，搭出风采!",
            pic: "tashenghuo",
            link: "http://www.shelive.net/"
        },
        {
            name: "美甲帮",
            description: "美甲帮提供美甲图片2018新款式，简单好看的美甲图片、美甲教程视频、美甲最新款式，包括法式美甲、日式美甲、光疗美甲等美甲图片和美甲知识，美甲APP应用",
            pic: "meijiabang",
            link: "https://www.meijiabang.cn/"
        },
        {
            name: "东方女性网",
            description: "专注于为女性朋友们供时尚潮流资讯、时尚女人搭配、潮流女人搭配等.特别是为东方女人提供全球时尚潮流资讯.女人我最大做时尚潮流女人就上东方女性网.",
            pic: "dongfangnvxingwang",
            link: "https://www.eastlady.cn/"
        },
        {
            name: "闺蜜网",
            description: "美妆互动媒体，收录19万款美容产品，逾2600万条用户口碑心得。从全面、实用、贴心的角度，为所有爱美人士提供全天候美妆资讯，更是你美丽消费的专业顾问",
            pic: "guimiwang",
            link: "http://www.kimiss.com/"
        },
        {
            name: "新浪女性",
            description: "中国著名女性网络品牌之一，汇集中文地区新鲜的女性资讯，全方位解读时尚、美妆新趋势，倡导健康生活方式，分享动人情感两性故事，引领精致女性风尚，全力打造专属于“她时代”的高端女性网络平台。",
            pic: "xinlangnvxing",
            link: "http://eladies.sina.com.cn/"
        },
        {
            name: "爱逛街",
            description: "一款阿里主打的手机购物软件,专门为女性用户打造。这款软件中女性使用的商品应有尽有,是一款在家购物...",
            pic: "aiguangjie",
            link: "https://lady.taobao.com/"
        },
        {
            name: "爱丽时尚",
            description: "作为领先的专业时尚类、生活方式类网站，专注于时装配饰、时尚产业、美容美体、护肤彩妆、珠宝腕表、新潮数码、汽车生活、艺术收藏、运动享乐等品质生活领域，爱丽时尚网全面打造融专业性、实用性",
            pic: "ailishishang",
            link: "http://www.aili.com/"
        },
        {
            name: "维度女性",
            description: "服务于中高收入群体的时尚女性综合门户网站，专注提供女性网潮流资讯,女性潮流服饰,女性网美容,女性网美体,女性网奢侈品,女性网健康,女性网情感,居家,亲子,女性网生活等全方位资讯",
            pic: "weidunvxing",
            link: "http://www.vdolady.com/"
        }
    ],
    chuxing: [
        {
            name: "12306",
            description: "全国列车时刻表查询及在线预订",
            pic: "12306",
            link: "https://www.12306.cn/index/"
        }, {
            name: "中国天气",
            description: "全中国天气网官方权威发布天气预报,逐三小时天气预报,提供天气预报查询一周,天气预报15天查询,天气预报40天查询,空气质量,生活指数,旅游出行,交通天气等查询服务",
            pic: "zhongguotianqi",
            link: "http://www.weather.com.cn/"
        },
        {
            name: "马蜂窝",
            description: "靠谱的旅游攻略,自由行,自助游分享社区,海量旅游景点图片、游记、交通、美食、购物等自由行旅游攻略信息,马蜂窝旅游网获取自由行,自助游攻略信息更全面",
            pic: "mafengwo",
            link: "http://www.mafengwo.cn/"
        },
        {
            name: "携程",
            description: "中国领先的在线旅行服务公司,向超过9000万会员提供酒店预订、酒店点评及特价酒店查询、机票预订、飞机票查询、时刻表、票价查询、航班查询、度假预订、商旅",
            pic: "xiecheng",
            link: "http://www.ctrip.com/"
        },
        {
            name: "飞猪",
            description: "阿里巴巴旗下的综合性旅游出行服务平台。飞猪整合数千家机票代理商、航空公司、旅行社、旅行代理商资源,...",
            pic: "feizhu",
            link: "https://www.fliggy.com/"
        },
        {
            name: "去哪儿网",
            description: "提供机票,飞机票,特价机票,打折机票的查询预订；99元春秋航空特惠折扣机票，百元南航、海航惊喜特价机票任您挑选,国航、深航1折特价机票和折扣机票一网打尽，更多打折机票尽在Qunar.com",
            pic: "qunaerwang",
            link: "https://www.qunar.com/"
        },
        {
            name: "缤客",
            description: "提供全世界国内外120,000多个目的地酒店在线预订且可享受超值优惠。查询符合您预算并提供最低价格保证的酒店。",
            pic: "binke",
            link: "https://www.booking.com/"
        },
        {
            name: "途牛",
            description: "提供跟团游、自助游、邮轮旅游、自驾游、定制游以及景点门票预订、机票预订、火车票预订服务,还有牛人专线、首付出发旅游等品质高端、价格实惠的旅游路线.全年有各种尾货特价",
            pic: "tuniu",
            link: "http://www.tuniu.com/"
        },
        {
            name: "同程旅游",
            description: "一家专业的一站式旅游预订平台，提供近万家景点门票、特价机票、出国旅游、周边游、自驾游及酒店预订服务；专业旅游线路服务、让您的旅行更安心！",
            pic: "tongchenglvyou",
            link: "https://www.ly.com/"
        },
        {
            name: "艺龙",
            description: "国领先的在线旅行服务提供商，纳斯达克上市公司(NASDAQ: LONG)。提供全球57万家酒店预订服务，2015年艺龙用户入住了4000万以上的间夜。低价有房保障，到店无房赔付",
            pic: "yilong",
            link: "http://www.elong.com/"
        }
    ],
    sheying: [
        {
            name: "蜂鸟网",
            description: "中国专业摄影门户网站,学习摄影技巧、分享摄影图片,这里有极具个性的摄影作品,全新数码相机、镜头等摄影器材的行情评测;涉及生活摄影、旅游摄影、风光摄影等.",
            pic: "fengniaowang",
            link: "http://www.fengniao.com/"
        },
        {
            name: "POCO",
            description: "图片分享社区是中国领先时尚的图片分享平台，最大的以原创图片为核心的分享社区，汇聚百万摄影与视觉爱好者，和你发现和分享最新最时尚的潮流",
            pic: "poco",
            link: "http://www.poco.cn/"
        },
        {
            name: "色摄无忌",
            description: "中文影像生活门户，发布及时的影像和摄影行业动态新闻和权威的器材评测和产品资讯，提供高质量的摄影作品发布，摄影技巧交流与分享，拥有活跃度极高的摄影论坛，全球最完整的器材库，摄影器材购买",
            pic: "seshewuji",
            link: "http://ww.xitek.com/"
        },
        {
            name: "摄影部落",
            description: "中国原创数码摄影社区--太平洋摄影部落，提供稳定高速、图片无限上传的个人摄影空间，友善的界面与强大的功能，为用户提供良好的使用体验。摄影部落每天有6000张以上的图片上传，",
            pic: "sheyingbuluo",
            link: "https://dp.pconline.com.cn/"
        },
        {
            name: "国家地理",
            description: "美国国家地理中文网是由《华夏地理》杂志与美国国家地理版权合作的科技人文线上平台，美国国家地理中文网囊括了生物与环境、历史与文化、旅游与探险等众多极具特色的专题栏目，将以影像和视频的呈现方式",
            pic: "guojiadili",
            link: "http://www.ngchina.com.cn/"
        },
        {
            name: "1x",
            description: "一个优秀的摄影作品网站,是由Jacob Jovelou和Ralf Stelander于2007年在瑞典乌普萨拉创建。",
            pic: "1x",
            link: "https://1x.com/"
        },
        {
            name: "500px",
            description: "A global photography network and app where over 15 million creatives discover and share incredible photos, gain meaningful exposure, and get paid for their.",
            pic: "500px",
            link: "https://500px.com/"
        },
        {
            name: "视觉联盟",
            description: "一家致力于传播优秀视觉文化,研究视觉艺术、交流视觉理念、开拓大众审美视野的专业性视觉网站。 ",
            pic: "shijuelianmeng",
            link: "http://www.cnu.cc/"
        },
        {
            name: "网易摄影",
            description: "摄影爱好者相片存储，作品展示，讨论分享的专业摄影社区。通过主题展区、精品专题、热门活动多维度诠释摄影作品。",
            pic: "wangyisheying",
            link: "http://pp.163.com/square/"
        },
        {
            name: "pexels",
            description: "Free stock photos you can use everywhere. ✓ Free for commercial use ✓ No attribution required",
            pic: "pexels",
            link: "https://www.pexels.com/"
        },
        {
            name: "大美摄影",
            description: "一家专注于摄影知识、摄影基础、摄影教程、摄影技巧、摄影入门、摄影资讯等摄影知识的O2O专业平台,大美摄影让你在学习摄影的路上更加平坦,大美摄影欢迎您!",
            pic: "dameisheying",
            link: "http://www.photodamei.com/"
        },
        {
            name: "新浪图片",
            description: "以图为媒，速递新闻；在这里，每天看“有温度的视觉”。频道致力于成为中国报道摄影师成长平台。以影像记录中国，发掘历史，感知世界。",
            pic: "xinlangtupian",
            link: "http://photo.sina.com.cn/"
        },
        {
            name: "摄影巴士",
            description: "网汇聚无数知名摄影师的摄影经验和技巧,为摄影爱好者提供器材选购、构图用光、后期处理等各类摄影知识,是国内最好的摄影学习平台",
            pic: "sheyingbashi",
            link: "http://www.fsbus.com/"
        },
        {
            name: "黑光网",
            description: "中国影楼行业门户网站，中国人像摄影学会合作媒体，汇集中国影楼人才，提供摄影,化妆,影楼资讯、影楼摄影作品、摄影教程、摄影器材、化妆教程、影楼化妆造型、影楼后期设计制作、影楼管理、影楼装修、婚礼策划等行业信息",
            pic: "heiguangwang",
            link: "https://www.heiguang.com/"
        },
        {
            name: "图虫网",
            description: "500多万摄影师入驻的优质摄影图片分享社区，下属纪实、风光、人像、生态、黑白、器材、佳能、尼康、宾得等几十个专业摄影社区。海量的照片、相册和图博全部由摄影师共同管理和维护。",
            pic: "tuchongwang",
            link: "https://tuchong.com/"
        },
        {
            name: "橡树摄影",
            description: "网是中国最具影响力的著名摄影网站,摄友和驴友的家园,网站创办于2004年,至今拥有超过80万注册会员和4万VIP付费会员,编著出版了20多本摄影图书。",
            pic: "xiangshusheying",
            link: "http://www.xiangshu.com/"
        }
    ],
    sheji: [
        {
            name: "站酷",
            description: "中国设计师互动平台。深耕设计领域十二年,站酷聚集了650万设计师、摄影师、插画师、艺术家、创意人,设计创意群体中具有较高的影响力与号召力。",
            pic: "zhanku",
            link: "https://www.zcool.com.cn/"
        },
        {
            name: "花瓣",
            description: "设计师寻找灵感的天堂!图片素材领导者,帮你采集,发现网络上你喜欢的事物.你可以用它收集灵感,保存有用的素材,计划旅行,晒晒自己想要的东西",
            pic: "huaban",
            link: "https://huaban.com/"
        },
        {
            name: "Behance",
            description: "Best of Behance Curated Galleries Creative Tools Schools &amp; Organizations Showcase &amp; DiscoverCreative",
            pic: "behance",
            link: "http://www.behance.net/"
        },
        {
            name: "Pinterest",
            description: "采用的是瀑布流的形式展现图片内容，无需用户翻页，新的图片不断自动加载在页面底端，让用户不断的发现新的图片。Pinterest堪称图片版的Twitter，网民可以将感兴趣的.",
            pic: "pinterest",
            link: "https://www.pinterest.com/"
        },
        {
            name: "千库网",
            description: "国内设计师喜欢的图片素材库,588ku.com为设计师提供各类好看免费的png图片和素材、背景图片、背景素材、海报背景、banner背景、边框花纹素材、艺术字",
            pic: "qiankuwang",
            link: "http://588ku.com/"
        },
        {
            name: "包图网",
            description: "汇集了各种流行趋势,视觉冲击力强的原创广告图片设计、电商淘宝、企业办公模板素材,由顶尖的设计师供稿,符合各个行业的商用需求,下载高品质正版素材就到包图网。",
            pic: "baotuwang",
            link: "https://ibaotu.com/"
        },
        {
            name: "千图网",
            description: "专注免费设计素材下载的网站!提供矢量图素材,矢量背景图片,矢量图库,还有psd素材,PS素材,设计模板,设计素材,PPT素材,以及网页素材,网站",
            pic: "qiantuwang",
            link: "http://www.58pic.com/"
        },
        {
            name: "大作",
            description: "专为各行业设计师度身定制的设计灵感搜索引擎，聚合全球众多知名设计网站，目前在库21.2亿创意设计、设计素材、摄影大图，并且保持每日更新量在25万张以上。",
            pic: "dazuo",
            link: "https://www.bigbigwork.com/"
        },
        {
            name: "90设计",
            description: "专注电商设计的淘宝素材库，设计交流、学习与分享一体的平台，让电商设计（淘宝美工）找灵感和素材更效率。",
            pic: "90sheji",
            link: "http://90sheji.com/"
        },
        {
            name: "创客贴",
            description: "极简好用的平面设计作图软件,在线图片编辑器,免费使用.提供免费设计模板，有海报、名片、公众号图片、PPT、邀请函等65个场景模板,一键稿定设计印刷",
            pic: "chuangketie",
            link: "https://www.chuangkit.com"
        },
        {
            name: "稿定设计",
            description: "让设计更简单。稿定设计是一个简单有趣的图片视频设计平台，提供大量免费设计素材和免费设计和视频模板、在线抠图和电商海报设计模板等，一键搞定设计需求。",
            pic: "gaodingsheji",
            link: "https://www.gaoding.com/"
        },
        {
            name: "凡科快图",
            description: "在线制作图片,图片编辑工具,图片制作软件,在线图片编辑器,在线图片处理,文字图片制作,平面设计软件",
            pic: "fankekuaitu",
            link: "https://kt.fkw.com/"
        },
        {
            name: "阿里图标",
            description: "Iconfont-国内功能很强大且图标内容很丰富的矢量图标库，提供矢量图标下载、在线存储、格式转换等功能。阿里巴巴体验团队倾力打造，设计和前端开发的便捷工具",
            pic: "alitubiao",
            link: "https://www.iconfont.cn/"
        },
        {
            name: "unDraw",
            description: "Illustrations/svg...矢量图片下载",
            pic: "undraw",
            link: "https://undraw.co/illustrations"
        },
        {
            name: "pngimg",
            description: "搜罗上万张高质量PNG素材",
            pic: "pngimg",
            link: "http://pngimg.com/"
        },
        {
            name: "底纹下载",
            description: "提供在线编辑纹理的功能，纹理效果实时预览，纹理可以选择 png 的透明底格式，也可以创建 JPG 格式壁纸。很不错的PNG透明纹理下载，适用网站背景。",
            pic: "transparenttextures",
            link: "https://www.transparenttextures.com/"
        },
        {
            name: "cssgradient",
            description: "网上最佳渐变网站的精选列表",
            pic: "cssgradient",
            link: "https://cssgradient.io/gradient-backgrounds/"
        },
        {
            name: "爱给",
            description: "免费素材下载网站,免费提供免费的音效配乐|3D模型|视频|游戏素材资源下载。",
            pic: "aigei",
            link: "http://www.aigei.com/"
        },
        {
            name: "Ps联盟",
            description: "Photoshop专业教程网，提供专业/详细的Photoshop（PS）教程、使用技巧、图片处理技术、漂亮的文字效果，以及各类视频教程",
            pic: "pslianmeng",
            link: "https://68ps.com/"
        },
        {
            name: "视达网",
            description: "一家设计师培训网站，这里提供的视频教程包含ps教程、ps视频教程、电商运营、海报、平面设计、字体设计、c4d教程、ai教程等，您可在线传授技能，亦可在线学习你所需的一技之长。",
            pic: "shidawang",
            link: "http://shida66.com/"
        },
        {
            name: "46设计师",
            description: "最全的设计师导航网站，电商网页UI设计师必备的设计网址导航网站大全，精选优秀设计网站、设计教程、免费无版权可商用设计素材下载和设计技巧",
            pic: "46shejishi",
            link: "http://www.46design.com/"
        },
        {
            name: "觅元素",
            description: "设计元素免费下载,免抠素材,位图,透明背景素材,透明背景图片,免抠png,高清png,图片素材,漂浮元素,装饰元素,节日元素,动植物元素,字体元素,标签元素,设计元素",
            pic: "miyuansu",
            link: "http://www.51yuansu.com/"
        },
        {
            name: "removebg",
            description: "消除图片背景：100% 自动 – 只需 5 秒 – 无需点击 – 免费。",
            pic: "removebg",
            link: "https://www.remove.bg/zh"
        },
        {
            name: "TOPYS",
            description: "顶尖文案,顶尖创意,灵感库,创意,艺术,设计,商业,文化,科技,广告,文案,分享平台,创意阅读,创意内容,灵感视频,灵感手抄本",
            pic: "topys",
            link: "https://www.topys.cn/"
        },
        {
            name: "优设导航",
            description: "专为设计师提供ps教程、UI设计、素材下载、高清图库、配色方案、用户体验、网页设计等全方位设计师网站导航指引。",
            pic: "youshedaohang",
            link: "https://hao.uisdc.com/"
        },
        {
            name: "设计师导航",
            description: "专注分享优秀设计网站、免费无版权限制可商用的高品质素材,设计教程、尺寸规范、配色方案、设计素材和灵感",
            pic: "shejishidaohang",
            link: "http://hao.shejidaren.com/"
        },
        {
            name: "搜图导航",
            description: "精选及整理国内外最优秀的设计行业网站,根据工种智能推荐、账号收藏云同步、自定义站点、只为创意而生,给你最全面的设计网址导航。包含免费素材,设计工具,...",
            pic: "91sotu",
            link: "https://www.91sotu.com/"
        }
    ],
    jianji: [
        {
            name: "NEWCGER",
            description: "致力于为广大影视后期设计师打造相互交流、分享作品与经验的互动平台。",
            pic: "newcger",
            link: "https://www.newcger.com/"
        },
        {
            name: "LOOKAE",
            description: "大众脸为您提供的后期技术交流平台，欢迎您的到来。",
            pic: "lookae",
            link: "https://www.lookae.com/"
        },
        {
            name: "网易见外",
            description: "网易人工智能旗下AI视频翻译产品,支持一键生成双语字幕",
            pic: "wangyijianwai",
            link: "https://jianwai.youdao.com/"
        },
        {
            name: "语音合成",
            description: "在线语音合成服务可进行在线文字转换成语音,可以输入300字以内的文本进行在线语音合成。",
            pic: "zaixianai",
            link: "http://www.zaixianai.cn/voiceCompose"
        },
        {
            name: "预告片世界",
            description: "提供最新、最热门的高清电影预告片、电影花絮、精彩片段的在线观看和免费下载。",
            pic: "yugaopian",
            link: "https://www.yugaopian.cn/"
        },
        {
            name: "爱给",
            description: "免费素材下载网站,免费提供免费的音效配乐|3D模型|视频|游戏素材资源下载。",
            pic: "aigei",
            link: "http://www.aigei.com/"
        },
        {
            name: "耳聆网",
            description: "中国最专业的声音分享平台，汇聚了国内众多专业录音师和业余声音爱好者，拥有庞大的声音资源云库和完善的版权保护及授权机制，满足音乐创作、影视后期、游戏配乐等领域的音频素材需求。",
            pic: "erlingwang",
            link: "https://www.ear0.com/"
        },
        {
            name: "牛片网",
            description: "专注影视广告资源整合,影视公司提供宣传片样片报价,广告片文案脚本策划,短视频拍摄,企业宣传片制作;创作人提供视频制作",
            pic: "6pian",
            link: "https://www.6pian.cn/"
        },
        {
            name: "Mixkit",
            description: "Browse our library of extraordinary free stock footage and motion clips for every occasion. All HD Video Clips are completely free to download and use anywhere.",
            pic: "mixkit",
            link: "https://mixkit.co/free-stock-video/"
        },
        {
            name: "Vj师",
            description: "中国领先的视频素材、AE模板的交易及下载网站，在这里设计师可以快速赚钱，买方可以快速找到所需素材。",
            pic: "vjshi",
            link: "https://www.vjshi.com/"
        },
    ],
    chengxuyuan: [
        {
            name: "W3c",
            description: "全球最大的中文 Web 技术教程。... W3C 术语表 字符集 HTML 字符集 HTML ASCII HTML ISO-8859-1 HTML 符号 实例/案例 HTML 实例 CSS 实例 XML 实例 JavaScript..",
            pic: "w3school",
            link: "http://www.w3school.com.cn/"
        },
        {
            name: "菜鸟教程",
            description: "提供了编程的基础技术教程, 介绍了HTML、CSS、Javascript、Python,Java,Ruby,C,PHP , MySQL等各种编程语言的基础知识。 同时本站中也...",
            pic: "cainiaojiaocheng",
            link: "http://www.runoob.com/"
        },
        {
            name: "CSDN",
            description: "2018博客之星年度评选正式上线,快为你喜欢的博主投票吧! 年后跳槽BAT必看:10种数据结构、算法和编程课助你面试通关 Windows 10 终于干掉了 Windows 7! ...",
            pic: "csdn",
            link: "https://www.csdn.net/"
        },
        {
            name: "站长之家",
            description: "站长的必备工具。经常上站长工具可以了解SEO数据变化。还可以检测网站死链接、蜘蛛访问、HTML格式检测、网站速度测试、友情链接检查、网站域名IP查询、PR、...",
            pic: "zhanzhangzhijia",
            link: "http://tool.chinaz.com/"
        },
        {
            name: "开源中国",
            description: "目前中国最大的开源技术社区。我们传播开源的理念，推广开源项目，为 IT 开发者提供了一个发现、使用、并交流开源技术的平台。目前开源中国社区已收录超过两万款开源软件。",
            pic: "kaiyuanzhongguo",
            link: "https://www.oschina.net/"
        },
        {
            name: "酷壳",
            description: "享受编程和技术所带来的快乐 ",
            pic: "kuke",
            link: "https://coolshell.cn/"
        },
        {
            name: "V2EX",
            description: "一个汇集各类奇妙好玩的话题和流行动向的网站。",
            pic: "v2ex",
            link: "https://www.v2ex.com/"
        },
        {
            name: "InfoQ",
            description: "一个实践驱动的社区资讯站点，致力于促进软件开发领域知识与创新的传播。",
            pic: "infoq",
            link: "https://www.infoq.cn/"
        },
        {
            name: "stackoverflow",
            description: "当你碰到任何编程问题，就去搜索该问题，如果没有解决方法就提问吧。",
            pic: "stackoverflow",
            link: "https://stackoverflow.com/"
        },
        {
            name: "Github",
            description: "作为开源代码库以及版本控制系统，Github拥有140多万开发者用户。随着越来越多的应用程序转移到了云上，Github已经成为了管理软件开发以及发现已有代码的首选方法",
            pic: "github",
            link: "https://github.com/"
        },
        {
            name: "码云",
            description: "是 OSCHINA.NET 推出的代码托管平台,支持 Git 和 SVN,提供免费的私有仓库托管。目前已有近 400 万的开发者选择码云。",
            pic: "mayun",
            link: "https://gitee.com/"
        },
        {
            name: "Parallax",
            description: "Parallax Scrolling, Java Cryptography, YAML, Python Data Science, Java i18n, GitLab, TestRail, VersionOne, DBUtils, Common CLI, Seaborn, Ansible, LOLCODE, Current Affairs 2018, Intellij Idea, Apache Commons Collections, Java 9, GSON, TestLink, Inter Process Communication (IPC), Logo, PySpark, Google Tag Manager, Free IFSC Code, SAP Workflow",
            pic: "parallax",
            link: "https://www.tutorialspoint.com/"
        },
        {
            name: "36氪",
            description: "为您提供创业资讯、科技新闻、投融资对接、股权投资、极速融资等创业服务，致力成为创业者可以依赖的创业服务平台，为创业者提供最好的产品和服务。",
            pic: "36ke",
            link: "https://www.36kr.com/"
        },
        {
            name: "脚本之家",
            description: "国内专业的网站建设资源、脚本编程学习类网站，提供asp、php、asp.net、javascript、jquery、vbscript、dos批处理、网页制作、网络编程、网站建设等编程资料。",
            pic: "jiaobenzhijia",
            link: "https://www.jb51.net/"
        },
        {
            name: "掘金",
            description: "一个帮助开发者成长的社区，是给开发者用的 Hacker News，给设计师用的 Designer News，和给产品经理用的 Medium。掘金的技术文章由稀土上聚集的技术大牛和极客共同编辑为你筛选出最优质的干货",
            pic: "juejin",
            link: "https://juejin.im/"
        },
        {
            name: "实验楼",
            description: "国内领先的IT在线编程及在线实训学习平台，专业导师提供精选的实践项目，创新的技术使得学习者无需配置繁琐的本地环境，随时在线流畅使用。以就业为导向，提供编程、运维、测试、云计算、大数据、数据库等",
            pic: "shiyanlou",
            link: "https://www.shiyanlou.com/"
        },
        {
            name: "CODELF",
            description: "变量命名神器!Codelf,变量命名,函数命名,方法命名,变量命名神器,GitHub 分组,Organize GitHub stars,naming things,naming convention,programming naming",
            pic: "codelf",
            link: "https://codeif.xinke.org.cn//"
        },
        {
            name: "BootCDN",
            description: "开源项目免费 CDN 加速服务 - 我们致力于为 Bootstrap、jQuery、Angular、Vue.js 一样优秀的开源项目提供稳定、快速、免费的 CDN 加速服务。Boot...",
            pic: "bootcdn",
            link: "https://www.bootcdn.cn/"
        },
        {
            name: "MDN",
            description: "网站提供开放网络(Open Web)技术有关的信息,包括用于网站和渐进式网络应用的 HTML、CSS 和 API。",
            pic: "mdn",
            link: "https://developer.mozilla.org/zh-CN/"
        },
        {
            name: "ALAPI",
            description: "免费API服务,支持短网址缩短,快递查询,天气接口,翻译接口,网易云接口等... ALAPI,免费API服务,支持短网址缩短,快递查询,天气接口,翻译接口,网易云接口等...",
            pic: "alapi",
            link: "https://www.alapi.net/"
        },
        {
            name: "Vue",
            description: "一套构建用户界面的渐进式框架。 Vue 只关注视图层, 采用自底向上增量开发的设计。",
            pic: "vue",
            link: "https://cn.vuejs.org/"
        },
        {
            name: "React",
            description: "使用一个名为 render() 的方法,接收输入的数据并返回需要展示的内容。在示例中这种类似 XML 的写法被称为 JSX。",
            pic: "react",
            link: "https://react.docschina.org/"
        },
        {
            name: "Picsum",
            description: "随机生成图片,可以将精美的图片直接放置到需要放置图片的地方",
            pic: "picsum",
            link: "https://picsum.photos/"
        },
        {
            name: "插件库",
            description: "jQuery插件库-收集最全最新最好的jQuery插件",
            pic: "jq22",
            link: "http://www.jq22.com/"
        },
        {
            name: "codepen",
            description: "优秀前端demo的展示。",
            pic: "codepen",
            link: "https://codepen.io/"
        },
        {
            name: "极客导航",
            description: "中国专业IT职业在线教育平台,拥有海量高清IT职业课程,涵盖30+个技术领域,如Android,iOS",
            pic: "jikedaohang",
            link: "https://www.jikedaohang.com/"
        },
        {
            name: "animista",
            description: "CSS动态效果样式自定义",
            pic: "animista",
            link: "https://animista.net/"
        },
        {
            name: "AniCollection",
            description: "CSS动态效果预设收藏集合",
            pic: "anicollection",
            link: "http://anicollection.github.io/"
        },
        {
            name: "Animate.css",
            description: "一款强大的预设css3动画库",
            pic: "Animate",
            link: "https://daneden.github.io/animate.css/"
        },
        {
            name: "WOW.js",
            description: "一款帮助你实现滚动页面时触发CSS 动画效果的插件",
            pic: "wow",
            link: "https://www.delac.io/wow/"
        },
    ],
    xinmeiti: [
        {
            name: "鸟哥笔记",
            description: "分享App运营推广实战经验、新媒体营销、小程序、抖音营销案例,致力于帮助从业者高效提升专业技能、推动...",
            pic: "niaogebiji",
            link: "https://www.niaogebiji.com/"
        },
        {
            name: "知微事见",
            description: "全的互联网社会热点聚合平台,最深度的事件真相解读,在这里,读懂网络中国。... @社会网络与数据挖掘",
            pic: "zhiweishijian",
            link: "https://ef.zhiweidata.com/"
        },
        {
            name: "产品经理",
            description: "人人都是产品经理致力为产品新人、产品经理等广大产品爱好者打造一个良好的学习交流平台。深度剖析国内外互联网业内动态,分享产品设计、交互设计、视觉设计、用户体验...",
            pic: "woshipm",
            link: "http://www.woshipm.com/"
        },
        {
            name: "句易网",
            description: "为您提供2020年最新广告法违禁词在线过滤工具,欢迎使用,工具适用于各类房地产,医疗等行业文案新闻稿检查,词库包含各类禁语极限用语,不断完善中...",
            pic: "juyiwang",
            link: "http://www.ju1.cn/"
        },
        {
            name: "3节课",
            description: "互联网人的在线大学,为您提供专业成体系的产品经理培训课程、互联网运营培训课程及营销培训课程,三节课是专注于“能力提升”的互联网人在线大学,志愿者和...",
            pic: "sanjieke",
            link: "https://www.sanjieke.cn/"
        },
        {
            name: "文案狗",
            description: "给文案狗一点灵感。收集各种中文创意文案,广告语,让您取名,找slogan不再难。",
            pic: "wenangou",
            link: "http://wenangou.com/"
        },
        {
            name: "易媒",
            description: "新自媒体运营数据分析、舆情监测、表单工具、内容分发平台大全",
            pic: "yimei",
            link: "https://www.yimeizhushou.cn/daohang.html"
        },
        {
            name: "Cnwebe",
            description: "免费学习新媒体运营、品牌营销、广告文案、社群运营、用户运营等相关知识,由浅入深,让你从新媒体营销小白变大神。我们邀请了大批新媒体、自...全",
            pic: "cnwebe",
            link: "https://www.cnwebe.com/"
        },
        {
            name: "搜外工具",
            description: "EO工具大全，收集资深SEO从业者常用的各类SEO站长工具，包括综合查询、外链工具、长尾挖掘、排名工具等。",
            pic: "seowhy",
            link: "http://tool.seowhy.com/"
        },
    ],
    waimao: [
        {
            name: "阿里巴巴",
            description: "Find quality Manufacturers, Suppliers, Exporters, Importers, Buyers, Wholesalers, Products and Trade Leads from our award-winning International Trade Site. Import &amp; Export on alibaba.com",
            pic: "alibaba",
            link: "https://www.alibaba.com/"
        },
        {
            name: "Facebook",
            description: "美国的一个社交网络服务网站 ，创立于2004年2月4日，总部位于美国加利福尼亚州门洛帕克",
            pic: "facebook",
            link: "https://www.facebook.com"
        },
        {
            name: "亚马逊",
            description: "美国最大的一家网络电子商务公司，位于华盛顿州的西雅图。是网络上最早开始经营电子商务的公司之一，亚马逊成立于1995年",
            pic: "yamaxun",
            link: "https://www.amazon.com/"
        },
        {
            name: "领英",
            description: "全球最大职业社交网站，是一家面向商业客户的社交网络（SNS），成立于2002年12月并于2003年启动，于2011年5月20日在美上市，总部位于美国加利福尼亚州山景城。",
            pic: "lingying",
            link: "https://www.linkedin.com"
        },
        {
            name: "外贸邦",
            description: "专注于海关数据体验研发，外贸数据互联网营销品牌服务商；百万外贸业务员都在使用的外贸数据平台，为业务员从事外贸客户开发、市场分析、调研提供了贸易数据支撑。",
            pic: "waimaobang",
            link: "https://www.52wmb.com/"
        },
        {
            name: "商桥",
            description: "外贸相关干货精选与分享；外贸社交媒体营运推广技巧；请关注“商桥新外贸”头条号，微信公众号 同名。",
            pic: "shangqiao",
            link: "https://www.ollomall.com/"
        },
        {
            name: "龙之向导",
            description: "专业收录世界各个国家的外贸B2B网站,国际商业黄页等各种优秀的外贸网站及电子商务平台,提供简单便捷的外贸导航服务,是数千万外贸人的学习、开拓国际客户的外贸网.外贸之旅,从龙之向导开始.",
            pic: "longzhixiangdao",
            link: "http://dragon-guide.net/"
        },
        {
            name: "重要节假日",
            description: "可以很好的找到客户和目标市场当地的节假日情况",
            pic: "zhongyaojiejiari",
            link: "https://www.timeanddate.com/"
        },
        {
            name: "亚马逊导航",
            description: "史上最全亚马逊卖家运营工具汇总!最专业的亚马逊卖家导航网站AMZ123.com,为Amazon卖家提供专业的常用工具。亚马逊大卖家成长之路，从AMZ123开始。",
            pic: "yamaxundaohang",
            link: "http://www.amz123.com/"
        },
        {
            name: "阿里外贸导航",
            description: "外贸免费实用工具-一图多链接|阿里国际站无线端排名查询|橱窗分析国际站第一品牌深圳市点石成金科技有限公司官方网站QQ800004196专注于阿里巴巴国际站营销推广软件开发",
            pic: "aliwaimaodaohang",
            link: "http://vgmc.cn/"
        },
        {
            name: "HS编码查询",
            description: "提供进出口商品HS编码查询,商品编码查询的网站。",
            pic: "hsbianmachaxun",
            link: "https://www.hsbianma.com/"
        },
        {
            name: "众筹网站",
            description: "著名的的众筹网站，带你了解最新奇的产品前沿",
            pic: "zhongchouwangzhan",
            link: "https://www.indiegogo.com/"
        }
    ],
    meiri: [
        {
            name: "今日热榜",
            description: "今日热榜提供各站热榜聚合：微信、今日头条、百度、知乎、V2EX、微博、贴吧、豆瓣、天涯、虎扑、Github、抖音...追踪全网热点、简单高效阅读。",
            pic: "jinrirebang",
            link: "https://tophub.today"
        },
        {
            name: "AnyKnew",
            description: "效率资讯 - 高效读新闻, 5分钟遍历全网热点",
            pic: "anyknew",
            link: "https://www.anyknew.com/"
        },
        {
            name: "果汁排行榜",
            description: "果汁导航旗下一键式快速查询各类排行榜的网站，网站囊括了热搜、热议、电影、音乐、摄影、游戏、财富等各大领域权威排名榜单。",
            pic: "guozhipaihangbang",
            link: "http://guozhivip.com/rank/"
        },
        {
            name: "场库",
            description: "国内高品质短片分享平台,汇集优秀视频短片及微电影创作人,实时不断分享全球优秀视频短片,微电影等,提供电影幕后制作揭秘,全国各地举办线下视频短片和微电影展映交流活动",
            pic: "changku",
            link: "https://www.vmovier.com/"
        },
        {
            name: "搜狐",
            description: "搜狐网为用户提供24小时不间断的最新资讯,及搜索、邮件等网络服务。内容包括全球热点事件、突发新闻",
            pic: "sohu",
            link: "http://www.sohu.com/"
        },
        {
            name: "新浪网",
            description: "浪网为全球用户24小时提供全面及时的中文资讯，内容覆盖国内外突发新闻事件、体坛赛事、娱乐时尚、产业资",
            pic: "xinlang",
            link: "https://www.sina.com.cn/"
        },
        {
            name: "网易",
            description: "网易是中国领先的互联网技术公司,为用户提供免费邮箱、游戏、搜索引擎服务,开设新闻、娱乐、体育等30多个内容频道,及博客",
            pic: "wangyi",
            link: "https://www.163.com"
        },
        {
            name: "今日头条",
            description: "基于数据挖掘的推荐引擎产品,它为用户推荐有价值的、个性化的信息,提供连接人与信息的新型服务",
            pic: "toutiao",
            link: "https://www.toutiao.com"
        },
        {
            name: "ONE",
            description: "每天只为你准备一张图片、一篇文字和一个问答 韩寒主编和监制 原《独唱团》主创成员共同制作- 也可搜索 - 韩寒一个 或 ONE一个...",
            pic: "one",
            link: "http://wufazhuce.com/"
        },
        {
            name: "每日一文",
            description: "爱阅读,每日一文,每天一篇精彩文章!... 每日一文 文章 声音 书架 双琴祭梁晓声那两棵树,最适合取其材而做琴。并且,肯定能够做成两把音质优良的小提琴。",
            pic: "meiriyiwen",
            link: "https://meiriyiwen.com/"
        },
        {
            name: "东方财富",
            description: "上证指数,000001,东方财富网,大盘指数,个股,股票,行情,大盘,指数,板块,权证,基金,综合排行,自选股,高速行情。",
            pic: "dongfangcaifu",
            link: "http://quote.eastmoney.com/zs000001.html"
        }
    ],
    gongju: [
        {
            name: "娃娃工具",
            description: "一个包含大量在线工具网站，包含语言工具，便民查询，转换工具，生理健康，站长工具等，致力为广大网友提供便利的在线工具服务。",
            pic: "wawagongju",
            link: "https://www.iamwawa.cn/"
        },
        {
            name: "在线工具",
            description: "好工具网致力于收集打造各种简单易用在线工具，网友无需注册和下载安装即可使用。",
            pic: "zaixiangongju2",
            link: "https://www.zxgj.cn/"
        },
        {
            name: "吾爱破解",
            description: "致力于软件安全与病毒分析的前沿,丰富的技术版块交相辉映,由无数热衷于软件加密解密及反病毒爱好者共同维护",
            pic: "52pojie",
            link: "https://www.52pojie.cn/"
        },
        {
            name: "云端应用",
            description: "Ps、Ai、PPT、Excel 超级好用的云端超级应用空间",
            pic: "uzer",
            link: "https://uzer.me"
        },
        {
            name: "在线工具",
            description: "程序员的工具箱",
            pic: "zaixiangongju",
            link: "https://tool.lu/"
        },
        {
            name: "草料二维码",
            description: "国内专业的二维码服务提供商，提供二维码生成，美化，印制，管理，统计等服务，帮助企业通过二维码展示信息并采集线下数据，提升营销和管理效率。",
            pic: "caoliao",
            link: "https://cli.im/"
        },
        {
            name: "临时邮箱",
            description: "临时邮箱、10分钟邮箱、十分钟邮箱、临时邮、临时Email、快速注册Email、自动刷新接收！",
            pic: "linshiyouxiang",
            link: "https://www.linshiyouxiang.net/"
        },
        {
            name: "接号码",
            description: "在线短信接收平台,拥有中国、美国、英国号码接收短信验证码。临时虚拟手机号在线接收短信，接收短信网页版和APP，无需注册，界面简洁，短信显示迅速，保卫您的隐私",
            pic: "jiehaoma",
            link: "https://jiemahao.com/"
        },
        {
            name: "视频鱼",
            description: "视频鱼提供在线视频下载,持续更新。支持bilibili,acfun,芒果tv,cntv,新浪,搜狐等网站的视频下载",
            pic: "shipinyu",
            link: "http://shipinyu.com"
        },
        {
            name: "SBKKO",
            description: "日常干货在线工具网站分享平台 – SBKKO",
            pic: "sbkko",
            link: "https://www.sbkko.com/"
        },
        {
            name: "比特星球",
            description: "汇集全网优质网址及资源的中文上网导航。比特星球致力于为用户提供更简单、更实用、更贴心的导航服务。实时收录影视、音乐、小说、游戏、搜索等分类的网址和内容,让您的网络生活更简单精彩。",
            pic: "bitexingqiu",
            link: "https://www.btxqw.com/"
        },
        {
            name: "MindMaster",
            description: "在线思维导图软件,MindMaster网页版，MindMaster在线版，思维导图网页版",
            pic: "mindmaster",
            link: "https://mm.edrawsoft.cn/"
        },
        {
            name: "亿图",
            description: "轻松搞定200余种办公绘图",
            pic: "yitu",
            link: "https://www.edrawmax.cn/online/"
        },
        {
            name: "百度脑图",
            description: "便捷的脑图编辑工具。让您在线上直接创建、保存并分享你的思路。",
            pic: "baidunaotu",
            link: "https://naotu.baidu.com/"
        },
        {
            name: "自由钢琴",
            description: "致力于为钢琴爱好者、音乐爱好者提供一个优雅、简洁的平台，在学习工作之余可以在线弹钢琴",
            pic: "autopiano",
            link: "https://www.autopiano.cn/"
        },
        {
            name: "多搜搜",
            description: "搜图神器，为您提供图片搜索以及图片搜索引擎，推荐无版权图片，可商用图片，无版权可商用图片网站，并提供PPT工具，PPT模版，PPT背景图片，PPT教程，以及设计、建筑、规划、景观设计行业搜索聚合服务。",
            pic: "duososo",
            link: "http://duososo.com/"
        },
        {
            name: "EveryTimeZone",
            description: "很容易找到准确的时间差与视觉时区转换器。为你在世界各地的联系人、地点和地方找到会议时间。永远不要让你的大脑再次被时区数学扭曲。",
            pic: "everytimezone",
            link: "https://everytimezone.com/"
        },
        {
            name: "路过图床",
            description: "提供图片上传和图片外链服务, 原图保存, 全球CDN加速",
            pic: "imgchr",
            link: "https://imgchr.com/"
        }
    ]
}

